import { Action, actionCreator } from '@ardoq/rxbeach';
import { ArdoqId, LoadedState } from '@ardoq/api-types';
import { ForceReloadReason } from './actions';

export type SyncManagerResponseErrorPayload = {
  model: any;
  updateError: boolean;
  status: number;
  responseText: string | undefined;
  traceId?: string;
};

export const showSyncManagerError =
  actionCreator<SyncManagerResponseErrorPayload>(
    '[syncManagerError] showSyncManagerError'
  );

export const hideSyncManagerError = actionCreator(
  '[syncManagerError] hideSyncManagerError'
);

export type DynamicReloadDialogPayload =
  | { type: 'reloadWorkspaces'; workspaceIds: ArdoqId[] }
  | { type: 'reloadViewpoint'; loadedStates: LoadedState[] }
  | { type: 'reloadAction'; reloadAction: Action<unknown> };

export const showDynamicReloadDialog =
  actionCreator<DynamicReloadDialogPayload>(
    '[syncManagerError] showDynamicReloadDialog'
  );

export const hideDynamicReloadDialog = actionCreator(
  '[syncManagerError] hideDynamicReloadDialog'
);

export type ForceReloadPayload = {
  reason: ForceReloadReason;
  allowDismiss: boolean;
};

export const showForceReload = actionCreator<ForceReloadPayload>(
  '[syncManagerError] showForceReload'
);

export const hideForceReload = actionCreator(
  '[syncManagerError] hideForceReload'
);

export const showEventForbiddenError = actionCreator(
  '[syncManagerError] showEventForbiddenError'
);

export const hideEventForbiddenError = actionCreator(
  '[syncManagerError] hideEventForbiddenError'
);
